module.exports = __webpack_public_path__ + "img/australia-congenital-and-perinatal-diseases-female.7fc26948.png";